import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

export const MYPRICE_LOGIN_POPUP_CLICKED = 'MYPRICE_LOGIN_POPUP_CLICKED';
export const MYPRICE_LOGIN_POPUP_CLICKED_VERSION = '1.0';

export type MyPriceLoginPopupClickedPayload = {
  searchId: string;
};

export type MyPriceLoginPopupClickedParams = {
  searchParams: SearchParams;
};

export const createMyPriceLoginPopupClickedPayload = ({
  searchParams,
}: MyPriceLoginPopupClickedParams): MyPriceLoginPopupClickedPayload => {
  const searchId = searchParams[URLParameters.SEARCH_ID];

  return {
    searchId: searchId || '',
  };
};
